module.exports = __webpack_public_path__ + "static/media/Acrilico (30).938399dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (30).jpg
// module id = 298
// module chunks = 0